module.exports = __webpack_public_path__ + "static/media/0184_Medium.6b32e256.jpg";